import moment from 'moment';
import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import JSONPretty from 'react-json-pretty';
import JSONPrettyMon from 'react-json-pretty/dist/monikai';
import styled from 'styled-components';
import { Button } from '../../common/form';
import { HeaderMixin } from '../../shared/styles';
import { approveFundDataReview } from '../../../../services/lwadmin/fund/fund-service';

const SButton = styled(Button)`
  margin-right: 8px;
`;

const SModal = styled(Modal)`
  & > article.horizontal {
    min-width: 1200px;
    height:fit-content !important;
  }
`;

const Title = styled.h5`
  ${HeaderMixin};
  font-size: 14px;
  text-align: center;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const ColumnHeader = styled(Title)`
  ${HeaderMixin};
  font-size: 14px;
  text-align: left;
  margin: 4px 0px;
`;

const Body = styled(Modal.Body)`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: 20px 20px 0 20px;
  flex-wrap: wrap;
  padding: 0 !important;
  height: 100%;
`;

export default function DataReviewModal({ context }) {
  const {
    state: {
      showDataReviewModal,
      dataReview,
      fund: { id: fundId, name },
    }, dispatch,
  } = React.useContext(context);

  const [confirmStep, setConfirmStep] = React.useState(false);

  const dismiss = React.useCallback(e => {
    e && e.preventDefault();
    setConfirmStep(false);
    dispatch({ type: 'dismissDataReviewModal' });
  }, [dispatch]);

  if (!dataReview) {
    return null;
  }

  const {
    id: reviewId,
    current,
    toReview,
    createdAt,
  } = dataReview;

  const cancel = e => {
    e.preventDefault();

    if (confirmStep) {
      setConfirmStep(false);
    } else {
      dispatch({ type: 'dismissDataReviewModal' });
    }
  };

  const confirmOrApprove = e => {
    e.preventDefault();

    if (confirmStep) {
      setConfirmStep(false);
      approveFundDataReview(fundId, reviewId).then(() => dispatch({ type: 'dataReviewApproved', payload: { fundId, reviewId } }));
    } else {
      setConfirmStep(true);
    }
  };

  return (
    <SModal
      centered="true"
      dialogAs="article"
      dialogClassName="horizontal"
      show={showDataReviewModal}
      onHide={dismiss}
    >
      <Modal.Header>
        <Title>
          { name }
        </Title>
        <Title>
          Data Provider Update Review - (
          {moment(createdAt).format('DD/MM/YY @ h.mma')}
          )
        </Title>
      </Modal.Header>
      <Body>
        <Column>
          <ColumnHeader>Current</ColumnHeader>
          <JSONPretty id="current" data={current} theme={JSONPrettyMon} />
        </Column>
        <Column>
          <ColumnHeader>To review</ColumnHeader>
          <JSONPretty id="to-review" data={toReview} theme={JSONPrettyMon} />
        </Column>
      </Body>
      <Title>
        <SButton className="btn btn-default" onClick={cancel}>
          Cancel
        </SButton>
        <SButton className="btn btn-primary" onClick={confirmOrApprove}>
          {confirmStep ? 'Confirm' : 'Approve'}
        </SButton>
      </Title>
    </SModal>
  );
}

DataReviewModal.propTypes = {
  context: PropTypes.func.isRequired,
};
